import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

const HERO_BACKGROUNDS = {
  '/': "https://customer-assets.emergentagent.com/job_c40d2a50-2ea7-48bd-927c-1b6d899d3de9/artifacts/lvxh91xj_Round%20Shape%20Traditional%20Indian%20Wood%20Block%20Pattern%20for%20Textile%20Printing%20on%20Rustic%20Wood%20Background.%20Block%20Printing%2CRajasthan%20India%20Block%20Printing%2CWood%20Block%20Used%20for%20Handmade%20Textile%20Printing%2CHand%20Craft.jpg",
  '/about': "https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/q6qvxuog_Wood%2C%20Plastic%20Panels%2C%20High-Precision%20CNC%20Laser%20Cutting%2C%20High-Speed%20Cutting%2C%20Laser%20Welding%2C%20Laser%20Cutting%20Technology%2C%20Laser%20Welding..jpg",
  '/contact': "https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/67152p73_ChatGPT%20Image%20Apr%209%2C%202026%2C%2009_12_11%20AM.png",
};

const DEFAULT_BG = HERO_BACKGROUNDS['/'];

const PromotionalBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();
  const heroBg = HERO_BACKGROUNDS[location.pathname] || DEFAULT_BG;

  useEffect(() => {
    const bannerClosed = localStorage.getItem('promoBannerClosed');
    if (bannerClosed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const closeBanner = () => {
    setIsVisible(false);
    localStorage.setItem('promoBannerClosed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="relative overflow-hidden py-3 px-6" data-testid="promotional-banner">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('${heroBg}')` }} />
      <div className="absolute inset-0 bg-black/70" />
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 relative z-10">
        <img src="https://flagcdn.com/20x15/us.png" alt="USA" className="w-5 h-4" />
        <p className="text-sm md:text-base font-medium text-white" data-testid="promo-text">
          <strong>Celebrating the USA's 250th birthday</strong> | Use code 250AMERICA for 25% off
        </p>
        <img src="https://flagcdn.com/20x15/us.png" alt="USA" className="w-5 h-4" />
      </div>
      <button
        onClick={closeBanner}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-[#D4A843] transition-colors z-10"
        data-testid="close-promo-banner"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default PromotionalBanner;
